import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../context/userContext";
import { postData } from "../fetchRoutes/postData";

export default function MobileNavigation() {
    const [isOpen, setIsOpen] = useState(false);
    const [isClicked, setIsClicked] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const logoutUrl = process.env.REACT_APP_LOGOUT_USER;
    const { isLoggedIn, setIsLoggedIn, userDetails, setUserDetails } = useContext(UserContext);

    const toggleMenu = () => {
        setIsOpen(!isOpen);
        setIsClicked(true);
    };

    useEffect(() => {
        if (isTouched) {
            setIsOpen(false);
            setIsTouched(false);
            setIsClicked(false);
        }
    }, [isTouched]);

    const handleLogout = async () => {
        setIsLoading(true);
        try {
            const response = await postData(logoutUrl, userDetails);

            if (response.status === 'success') {
                setTimeout(() => {
                    setIsLoggedIn(false);
                    setUserDetails({
                        name: '',
                        email: '',
                        username: '',
                        role: ''
                    });
                }, 500);
            }
        } catch (err) {
            console.error('Error checking auth:', err);
            alert('An error occurred. Please try again later.');
        } finally {
            setIsLoading(false);
        }
    };

    const getDashboardLink = () => {
        if (userDetails.role === 'buyer') return '/buyer/dashboard';
        if (userDetails.role === 'admin') return '/admin/dashboard';
        if (userDetails.role === 'seller') return '/seller/dashboard';
        return '#';
    };

    return (
        <>
            <button onClick={toggleMenu} className={isClicked ? "openHumburger" : "closedHumburger"}>
                ☰
            </button>

            {isLoading ? (
                <div className="loaderContainer">
                    <div className="loader"></div>
                    <p className="loadingText">Logging out...</p>
                </div>
            ) : (
                isOpen && (
                    <div className={isOpen ? "openMenu" : "closedMenu"}>
                        <ul>
                            <li className="link">
                                <Link to="/" className="navLink">Home</Link>
                            </li>
                            <li className="link">
                                <Link to="/properties" className="navLink">Properties</Link>
                            </li>
                            <li className="link">
                                <Link to="/auctions" className="navLink">Auctions</Link>
                            </li>

                            {isLoggedIn ? (
                                <>
                                    <li className="link">
                                        <Link to={getDashboardLink()} className="navLink">
                                            <div className="linkLogin username">
                                                <span className="userIcon"></span>
                                                <span className="login">
                                                    {userDetails.name ? userDetails.name.split(" ")[0] : ""}
                                                </span>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/" className="navLink" onClick={handleLogout}>
                                            <div className="linkLogin">
                                                <span className="userIcon logoutIcon"></span>
                                                <span className="login">Logout</span>
                                            </div>
                                        </Link>
                                    </li>
                                </>
                            ) : (
                                <li>
                                    <Link to="/account/login" className="navLink">
                                        <div className="linkLogin">
                                            <span className="userIcon"></span>
                                            <span className="login">Log In</span>
                                        </div>
                                    </Link>
                                </li>
                            )}
                        </ul>
                    </div>
                )
            )}
        </>
    );
}
